import { Box, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const DashboardSkeleton = ({ loaderType }) => {
  return (
    <Box className="animate__animated animate__fadeIn">
      {loaderType === "internal" ? (
        // Full width content skeleton when loaderType is "internal"
        <Box width="100%" display="flex" flexDirection="column">
          {/* Main Content Skeleton */}
          <Box display="flex" flexDirection="column">
            <Skeleton variant="rectangular" height={200} />
            <Box py={2}>
              <Skeleton variant="rectangular" height={300} />
            </Box>
            <Box display="flex" justifyContent="space-between" py={2}>
              <Skeleton variant="rectangular" width="48%" height={150} />
              <Skeleton variant="rectangular" width="48%" height={150} />
            </Box>
          </Box>
        </Box>
      ) : loaderType === "login" ? (
        <Box display="flex" height="100vh">
          {/* Left Skeleton */}
          <Box width="50%">
            <Skeleton variant="rectangular" height="100%" />
          </Box>

          {/* Right Skeleton with Form */}
          <Box
            width="50%"
            padding={2}
            display="flex"
            flexDirection="column"
            bgcolor="white"
            borderRadius={1}
            boxShadow={1}
          >
            <Box paddingTop={20} px={16}>
              <Skeleton variant="text" width="60%" height={40} />
              <Skeleton variant="text" width="80%" height={30} my={2} />
              <Box py={1} marginTop={8}>
                <Skeleton variant="rectangular" width="95%" height={50} />
              </Box>
              <Box py={1}>
                <Skeleton variant="rectangular" width="100%" height={50} />
              </Box>
              <Box py={1}>
                <Skeleton variant="rectangular" width="100%" height={50} />
              </Box>
              <Box py={1}>
                <Skeleton variant="rectangular" width="100%" height={50} />
              </Box>
              <Box py={1}>
                <Skeleton variant="rectangular" width="50%" height={50} />
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          display="flex"
          height="100vh"
          sx={{ paddingTop: "10px", paddingLeft: "12px" }}
        >
          {/* Sidebar Skeleton */}
          <Box width="18%" padding={2}>
            <Skeleton
              variant="rectangular"
              height="100%"
              sx={{ borderRadius: "16px" }}
            />
          </Box>

          {/* Content Skeleton */}
          <Box
            width="calc(82% - 24px)"
            marginLeft="24px"
            py={2}
            paddingRight="24px"
            display="flex"
            flexDirection="column"
          >
            {/* Header Skeleton */}
            <Skeleton variant="text" width="30%" height={40} />

            {/* Main Content Skeleton */}
            <Box display="flex" flexDirection="column" marginTop={2}>
              <Skeleton variant="rectangular" height={200} />
              <Box display="flex" justifyContent="space-between" py={2}>
                <Skeleton variant="rectangular" width="48%" height={150} />
                <Skeleton variant="rectangular" width="48%" height={150} />
              </Box>
              <Skeleton variant="rectangular" height={300} marginTop={2} />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

DashboardSkeleton.propTypes = {
  loaderType: PropTypes.string
};

export default DashboardSkeleton;
